import { NullableItems } from 'pagination';

const areItemsLoading = <Entity>(items: NullableItems<Entity>): boolean =>
  items.length > 0 && items.every((item) => item === null);

export default areItemsLoading;
